import {Model} from './model';
import {Unserializer} from './serialization';

export class InvoiceAttachment implements Model {

  created: Date;
  description: string;
  invoiceAttachmentId: number;
  invoiceId: number;
  invoiceAttachmentTypeId?: number;
  isHidden: boolean;
  originalFileName: string;
  content: string;
  contentType: string;

  static copy(oldObj: InvoiceAttachment): InvoiceAttachment {
    const newObj = new InvoiceAttachment();
    newObj.created = Unserializer.date(oldObj.created);
    newObj.description = oldObj.description;
    newObj.invoiceAttachmentId = oldObj.invoiceAttachmentId;
    newObj.invoiceId = oldObj.invoiceId;
    newObj.invoiceAttachmentTypeId = oldObj.invoiceAttachmentTypeId;
    newObj.isHidden = oldObj.isHidden;
    newObj.originalFileName = oldObj.originalFileName;
    newObj.content = oldObj.content;
    newObj.contentType = oldObj.contentType;
    return newObj;
  }

  getPrimaryKey() {
    return this.invoiceAttachmentId;
  }

  isNew(): boolean {
    return isNaN(this.invoiceAttachmentId);
  }

  clone(): InvoiceAttachment {
    return InvoiceAttachment.copy(this);
  }
}
